module.exports = __webpack_public_path__ + "img/twitter.7cf31f46.svg";